export const frontmatter = {
    "title": "Glossary of terms",
    "description": "Official definition of all technical and business terms used in the OnnIA platform.",
    "sidebar_label": "Glossary",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []